import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

import { PatientPregnancyCompletionMarkingForm } from './PatientPregnancyCompletionMarkingForm';
import { PatientPregnancyCompletionMarkingModalConfirmButton } from './PatientPregnancyCompletionMarkingModalConfirmButton';

type PatientPregnancyCompletionMarkingModalProps = {
   readonly visitId: number;
   readonly onClose: VoidFunction;
   readonly onMark: VoidFunction;
};

export const PatientPregnancyCompletionMarkingModal = (
   props: PatientPregnancyCompletionMarkingModalProps
): JSX.Element => {
   return (
      <Modal
         title={visitPatientPregnancyStatusTranslationKeys.pregnancyCompletion}
         testId={'markPatientPregnancyCompletion'}
         width={ModalWidth.NORMAL}
      >
         <PatientPregnancyCompletionMarkingForm>
            {({ handleSubmit, formState }) => (
               <>
                  <PatientPregnancyCompletionMarkingModalConfirmButton
                     visitId={props.visitId}
                     handleSubmit={handleSubmit}
                     onSuccess={() => {
                        props.onMark();
                        props.onClose();
                     }}
                     registerMedicalEvent
                  />
                  <PatientPregnancyCompletionMarkingModalConfirmButton
                     visitId={props.visitId}
                     handleSubmit={handleSubmit}
                     onSuccess={() => {
                        props.onMark();
                        props.onClose();
                     }}
                     registerMedicalEvent={false}
                  />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </PatientPregnancyCompletionMarkingForm>
      </Modal>
   );
};
